import { CuisineOption } from "@/clients/models/CuisineOption";
import { SelectablePill } from "@/components/form/selectable-pill";
import { useFavoriteCuisines } from "@/hooks/features/use-favorite-cuisines";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";
import { SettingModalHeader } from "../../components/setting-modal-header";

interface FavoriteCuisinesPageProps {
  onBack?: () => void;
  isModal?: boolean;
}

const FavoriteCuisinesPage = memo(function FavoriteCuisinesPage({
  onBack,
  isModal,
}: FavoriteCuisinesPageProps) {
  const {
    cuisineList,
    selectedCuisines,
    setSelectedCuisines,
    handleSubmit,
    isUpdating,
    isFavoriteCuisinesLoading,
  } = useFavoriteCuisines(() => {
    onBack?.();
  });

  const toggleCuisine = (cuisineValue: CuisineOption) => {
    setSelectedCuisines((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(cuisineValue)) {
        newSet.delete(cuisineValue);
      } else {
        newSet.add(cuisineValue);
      }
      return newSet;
    });
  };

  if (isFavoriteCuisinesLoading) {
    return (
      <div className="w-full h-full bg-[#fcfbfb] overflow-y-auto no-scrollbar">
        <SettingModalHeader title="Favourite Cuisines" onBack={onBack} isModal={isModal} />
        <div className="px-9 pb-20 pt-4">
          <div className="grid grid-cols-2 gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <IonSkeletonText key={i} animated className="h-[42px] w-full rounded-full" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full bg-[#fcfbfb] overflow-y-auto no-scrollbar">
      <SettingModalHeader
        title="Favourite Cuisines"
        showSaveButton
        onSave={handleSubmit}
        onBack={onBack}
        isSaving={isUpdating}
        isModal={isModal}
      />

      <div className="px-9 pb-20 pt-4">
        <div className="grid grid-cols-2 gap-3 my-4">
          {cuisineList.map((cuisine) => (
            <SelectablePill
              key={cuisine.value}
              label={cuisine.name}
              selected={selectedCuisines.has(cuisine.value)}
              onClick={() => !isUpdating && toggleCuisine(cuisine.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export default FavoriteCuisinesPage;
